export default __webpack_public_path__ + "static/media/account-book.868088bd.svg";